import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["tagName", "innerRef", "isPlainText"];
import { useEffect, memo, useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { formatHtml } from '../sanitizers/HtmlSanitizer';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledText = styled(props => {
  const {
      tagName: Tag,
      innerRef: ref
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(Tag, Object.assign({
    ref: ref
  }, rest));
}).withConfig({
  displayName: "SanitizedText__StyledText",
  componentId: "sc-92ynb2-0"
})(["white-space:", ";table{margin-top:0;margin-bottom:0;}pre{white-space:pre-wrap;}[data-email-reply]{display:none;}"], ({
  isPlainText
}) => isPlainText && 'pre-wrap');
const propTypes = {
  body: PropTypes.string,
  className: PropTypes.string,
  formattingOptions: PropTypes.shape({
    allowedDomainsForIframe: PropTypes.arrayOf(PropTypes.instanceOf(RegExp)),
    isPlainText: PropTypes.bool,
    shouldAutolinkTwitter: PropTypes.bool,
    shouldIncludeReplies: PropTypes.bool,
    shouldOpenLinksInNewTab: PropTypes.bool,
    shouldPreserveNewlines: PropTypes.bool,
    shouldPreventAutoLinker: PropTypes.bool,
    shouldRemoveEmailSignature: PropTypes.bool,
    shouldRemoveGmailLineBreakBeforeReply: PropTypes.bool
  }),
  maxHeight: PropTypes.number,
  onExceedsMaxHeight: PropTypes.func,
  textSeleniumKey: PropTypes.string,
  WrapperComponent: PropTypes.elementType
};
const defaultProps = {
  WrapperComponent: 'div'
};
const SanitizedText = /*#__PURE__*/memo(({
  body,
  className,
  formattingOptions,
  maxHeight,
  onExceedsMaxHeight,
  textSeleniumKey,
  WrapperComponent
}) => {
  const fullHeightTextRef = useRef(null);
  const formattedBody = body ? formatHtml(body, Object.assign({}, formattingOptions)) : '';
  const handleExceedsMaxHeight = useCallback((onResize = true) => {
    if (!fullHeightTextRef || !fullHeightTextRef.current || !maxHeight) {
      return;
    }
    if (fullHeightTextRef.current.clientHeight > maxHeight) {
      if (onExceedsMaxHeight) onExceedsMaxHeight(true);
    } else if (onResize) {
      if (onExceedsMaxHeight) onExceedsMaxHeight(false);
    }
  }, [maxHeight, fullHeightTextRef, onExceedsMaxHeight]);
  useEffect(() => {
    const isNumericMaxHeight = maxHeight && !isNaN(maxHeight);
    const allowMaxHeightTruncation = isNumericMaxHeight && formattedBody;
    if (allowMaxHeightTruncation) {
      // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
      window.addEventListener('resize', handleExceedsMaxHeight);
      handleExceedsMaxHeight(false);
      return () => {
        // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
        window.removeEventListener('resize', handleExceedsMaxHeight);
      };
    }
    return undefined;
  }, [maxHeight, formattedBody, handleExceedsMaxHeight]);
  if (!formattedBody) {
    return null;
  }
  return /*#__PURE__*/_jsx(StyledText, {
    className: className,
    dangerouslySetInnerHTML: {
      __html: formattedBody
    },
    "data-test-id": textSeleniumKey,
    isPlainText: Boolean(formattingOptions && formattingOptions.isPlainText),
    tagName: WrapperComponent,
    innerRef: fullHeightTextRef
  });
});
SanitizedText.propTypes = propTypes;
/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
SanitizedText.defaultProps = defaultProps;
export default SanitizedText;